export default "__VITE_ASSET__C54fAWvn__"